import { DevicePresenceStateDto } from '@/api/generator';
import { injectStrict } from '@/utils/injectStrict';
import { useHubSubscription } from '@/utils/signalR';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { computed, MaybeRefOrGetter, Ref, ref, toRef } from 'vue';
import { useMemoize } from '@vueuse/core';
import { DeviceStatusHubKey } from './severity';

export function getDeviceStatusHubConnectionSignalR() {
  const connection = new HubConnectionBuilder()
    .withUrl('/deviceStatusHub')
    .withAutomaticReconnect([0, 2000, 10000, 30000])
    .build();
  return connection;
}

const cachedStateValue = useMemoize((_deviceId: string | undefined) => {
  return ref<DevicePresenceStateDto | undefined>();
});

export function useDeviceStatusSignalR(
  deviceId: MaybeRefOrGetter<string | undefined>,
): Ref<DevicePresenceStateDto | undefined> {
  const connection = injectStrict(DeviceStatusHubKey);

  const id = toRef(deviceId);

  useHubSubscription<DevicePresenceStateDto>({
    connection,
    event: 'DeviceStatusUpdated',
    key: id,
    onMessage: (value) => {
      if (value.id) {
        cachedStateValue(value.id).value = value;
      }
    },
    subscribe: (key) => connection.invoke('SubscribeDevice', key),
    unsubscribe: (token) => connection.invoke('UnsubscribeDevice', token),
  });

  return computed(() => {
    return cachedStateValue(id.value).value;
  });
}
